
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"10","viewBox":"0 0 9 10"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#593289","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round"}},[_c('path',{attrs:{"stroke-linejoin":"round","d":"M1 4.79l3.5-3.5L8 4.79"}}),_c('path',{attrs:{"d":"M4.5 1.79v7"}})])])
          )
        }
      }
    